// components/ContributorEditActions.jsx — Anamoria SPA
// v1.0 — PR-7a.2: shared compact edit-mode footer (Cancel + Save changes), matching the settled
//   WritePage .footer / .btnCancel / .btnReview styling so the text / photo / audio edit screens are
//   identical in size and position. Self-contained inline styles (per-page CSS modules untouched).
export default function ContributorEditActions({ onCancel, onSave, saving, saveLabel = 'Save changes', saveDisabled = false, leftContent = null }) {
  const disabled = saving || saveDisabled;
  return (
    <div style={S.footer}>
      {leftContent != null ? <span style={S.left}>{leftContent}</span> : <span />}
      <div style={S.btns}>
        <button type="button" style={S.cancel} onClick={onCancel} disabled={saving}>Cancel</button>
        <button type="button" style={{ ...S.save, ...(disabled ? S.saveOff : {}) }} onClick={onSave} disabled={disabled}>
          {saving ? 'Saving…' : saveLabel}
        </button>
      </div>
    </div>
  );
}
const S = {
  footer: {
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    padding: '10px 0 12px', marginTop: 12,
    borderTop: '1px solid var(--color-border-light, #edebe7)',
  },
  left: { color: 'var(--color-text-caption, #9a958c)', fontSize: 13 },
  btns: { display: 'flex', gap: 8, marginLeft: 'auto' },
  cancel: {
    padding: '9px 20px', borderRadius: 10, fontSize: 14, fontWeight: 600,
    background: 'transparent', color: 'var(--color-text-caption, #636e72)',
    border: '1.5px solid var(--color-border-light, #edebe7)', cursor: 'pointer',
  },
  save: {
    padding: '9px 24px', borderRadius: 10, fontSize: 14, fontWeight: 600,
    background: 'var(--color-sage-dark, #5b7a65)', color: 'var(--color-text-white, #fff)',
    border: 'none', cursor: 'pointer',
  },
  saveOff: { opacity: 0.4, cursor: 'not-allowed' },
};
